// extracted by mini-css-extract-plugin
module.exports = {"select":"select__1A4d2","wysiwyg":"wysiwyg__3DFKB","ql-editor":"ql-editor__1Ix-w"};